export default __webpack_public_path__ + "static/Deepscope_logo-457867d24d9aed7c9fcaa619bb9f43b3.png";